export default "__VITE_ASSET__85wuuYK1__"